import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Empty, Row, Col, Card } from "antd";
import OtherErrors from "@general/otherErrors";
import { Link } from "react-router-dom";
import StrikethroughPrice from "@general/strikethroughPrice";
import { apiUrl } from "@utils/apoloClient";


const UserConsulting = () => {
  const GETCONSULTATIONS = gql`
    query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
      getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        image
        capacity
        amountRial
        strikethroughRial
      }
    }
  `;

  const [consultationsDtatils, setConsultationsDtails] = useState([]);

  const [getConsultations, consultations] = useLazyQuery(GETCONSULTATIONS, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setConsultationsDtails(data?.getProducts);
    },
    onError(err) {
      console.log("Error while fetching consultation: ", err);
    },
  });
  useEffect(() => {
    getConsultations({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 100,
        },
        searchInput: {
          category: ["CONSULTATION"],
        },
      },
    });
  }, []);

  if (consultations.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  if (consultations.error) return <OtherErrors />;
  if (!consultationsDtatils.length)
    return (
      <>
        <Empty description={"در حال حاضر مشاوره ای موجود نیست!!!"} />
      </>
    );
  return (
    <>
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 50]}
        justify="center"
        align="middle"
        style={{ height: "100%" }}
      >
        {consultationsDtatils?.map((consultation) => {
          const {
            id,
            name,
            amountRial,
            strikethroughRial,
            image,
          } = consultation;
          return (
            <Col xl={6} lg={8} sm={12} xs={24} key={id}>
              <Link to={`/services/consultation-single/${id}`}>
                <Card
                  hoverable
                  className="package-card"
                  cover={
                    <img
                      alt="safatec"
                      src={`${apiUrl + image}`}
                      className="package-img"
                    />
                  }
                >
                  <h3 className="package-title">{name}</h3>
  
                  <span className="card-row">
                    <p>هزینه مشاوره: </p> 
                  </span>
                  <StrikethroughPrice
                    strikethroughRial={strikethroughRial}
                    amountRial={amountRial}
                  />
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default UserConsulting;
